import React from 'react'
import type {
  FieldErrors,
  UseFormClearErrors,
  UseFormRegister,
  UseFormSetError,
  UseFormSetValue,
} from 'react-hook-form'
import type { BankDetailsFormReturn } from 'pages/Contacts/hooks/useBankDetailsForm'
import type { ContactFiatInstrumentFormData } from 'pages/Contacts/schemas/contactFiatInstrumentSchema'
import { type FormFieldLabels } from 'pages/Contacts/types/fiatInstruments'
import { EurGbpBankDetails } from './shared/EurGbpBankDetails'

type EURBankDetailsProps = {
  formValues: ContactFiatInstrumentFormData
  errors: FieldErrors<ContactFiatInstrumentFormData>
  formFieldLabels: FormFieldLabels
  clearErrors: UseFormClearErrors<ContactFiatInstrumentFormData>
  register: UseFormRegister<ContactFiatInstrumentFormData>
  setError: UseFormSetError<ContactFiatInstrumentFormData>
  setValue: UseFormSetValue<ContactFiatInstrumentFormData>
  bankDetailsForm: BankDetailsFormReturn
}

export const EURBankDetails = ({
  formFieldLabels,
  formValues,
  errors,
  clearErrors,
  register,
  setError,
  setValue,
  bankDetailsForm,
}: EURBankDetailsProps) => {
  return (
    <EurGbpBankDetails
      variant="EUR"
      formFieldLabels={formFieldLabels}
      formValues={formValues}
      errors={errors}
      clearErrors={clearErrors}
      register={register}
      setError={setError}
      setValue={setValue}
      bankDetailsForm={bankDetailsForm}
    />
  )
}
